import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const exercicios = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    titulo: 'Ancoragem de Poder',
    subtitulo: 'Estado de Pico Instantâneo',
    descricao: 'Ative seu estado de alta performance em segundos. Técnica para acessar recursos internos ilimitados de confiança e presença.',
    nivel: 'Avançado',
    tempo: '45 min',
    resultado: 'Confiança Sob Demanda',
    link: '/exercicio-gratis/ancoragem-emocional',
  },
  {
    id: 2,
    icon: 'ri-brain-line',
    titulo: 'Reprogramação Neural',
    subtitulo: 'Técnica Swish Avançada',
    descricao: 'Elimine padrões limitantes e instale novos comportamentos de sucesso. Reprogramação mental em nível subconsciente profundo.',
    nivel: 'Expert',
    tempo: '60 min',
    resultado: 'Mudança Permanente',
    link: '/exercicio-gratis/tecnica-swish-pnl',
  },
  {
    id: 3,
    icon: 'ri-focus-3-line',
    titulo: 'Ressignificação',
    subtitulo: 'Reframing de Crenças',
    descricao: 'Transforme experiências negativas em recursos poderosos. Mude o significado de eventos e instale novas perspectivas.',
    nivel: 'Intermediário',
    tempo: '50 min',
    resultado: 'Nova Perspectiva',
    link: '/exercicio-gratis/ressignificacao-reframing-pnl',
  },
  {
    id: 4,
    icon: 'ri-fire-line',
    titulo: 'Encantations',
    subtitulo: 'Método Tony Robbins',
    descricao: 'Afirmações com movimento e emoção intensa. Reprograme seu sistema nervoso através de fisiologia, linguagem e estado.',
    nivel: 'Todos os Níveis',
    tempo: '30 min',
    resultado: 'Estado Energético Elevado',
    link: '/exercicio-gratis/encantations-tony-robbins',
  },
  {
    id: 5,
    icon: 'ri-time-line',
    titulo: 'Linha do Tempo',
    subtitulo: 'Viagem Temporal Mental',
    descricao: 'Acesse memórias e programe seu futuro. Técnica avançada de PNL para liberar traumas e consolidar objetivos estratégicos.',
    nivel: 'Expert',
    tempo: '70 min',
    resultado: 'Clareza e Liberação',
    link: '/exercicio-gratis/linha-tempo-pnl',
  },
  {
    id: 6,
    icon: 'ri-gem-line',
    titulo: 'Submodalidades',
    subtitulo: 'Controle Total da Experiência',
    descricao: 'Domine como seu cérebro codifica experiências. Amplifique memórias positivas e diminua negativas para maestria emocional.',
    nivel: 'Intermediário',
    tempo: '50 min',
    resultado: 'Maestria sobre Emoções',
    link: '/exercicio-gratis/submodalidades-pnl',
  },
];

const nivelCores: Record<string, string> = {
  'Avançado': 'bg-gold-500/10 text-gold-400 border border-gold-500/20',
  'Expert': 'bg-white/8 text-white/70 border border-white/15',
  'Intermediário': 'bg-white/5 text-white/50 border border-white/10',
  'Todos os Níveis': 'bg-gold-500/8 text-gold-400/70 border border-gold-500/15',
};

export default function ExerciciosPNLGamificados() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  return (
    <section className="py-28 bg-[#060606] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(201,164,64,0.05),transparent_55%)]"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Cabeçalho */}
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-gold-500/60"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.35em] uppercase font-['Montserrat']">
                Arsenal Completo
              </span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-gold-500/60"></div>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-5 leading-tight">
              Técnicas de<br />
              <span className="text-gold-400">Performance Mental</span>
            </h2>
            <p className="text-white/50 text-lg max-w-2xl mx-auto leading-relaxed font-['Montserrat'] font-light">
              Protocolos avançados de PNL clínica para reprogramação profunda, usados por profissionais e líderes de alta performance
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Stats */}
        <ScrollRevealWrapper animation="fade-up" delay={0.1}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14 max-w-3xl mx-auto">
            {[
              { numero: '6', label: 'Técnicas avançadas' },
              { numero: '10.247', label: 'Mentes reprogramadas' },
              { numero: '95%', label: 'Taxa de satisfação' },
              { numero: '4.9/5', label: 'Avaliação' },
            ].map((stat, i) => (
              <div key={i} className="bg-[#111111] border border-gold-500/10 p-5 rounded-xl text-center">
                <div className="font-display text-2xl font-bold text-gold-400 mb-1">{stat.numero}</div>
                <div className="text-xs text-white/35 font-['Montserrat'] tracking-wide uppercase">{stat.label}</div>
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>

        {/* Grid de exercícios */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {exercicios.map((exercicio, i) => (
            <ScrollRevealWrapper key={exercicio.id} animation="fade-up" delay={0.07 * i}>
              <div
                className={`group bg-[#111111] border rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer ${
                  hoveredCard === i
                    ? 'border-gold-500/40'
                    : 'border-gold-500/10'
                }`}
                onMouseEnter={() => setHoveredCard(i)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="p-7">
                  <div className="flex items-start justify-between mb-5">
                    <div className={`w-12 h-12 flex items-center justify-center rounded-xl transition-all duration-300 ${
                      hoveredCard === i ? 'bg-gold-500' : 'bg-gold-500/10 border border-gold-500/15'
                    }`}>
                      <i className={`${exercicio.icon} text-xl ${hoveredCard === i ? 'text-[#0a0a0a]' : 'text-gold-400'}`}></i>
                    </div>
                    <span className={`text-xs font-semibold px-3 py-1 rounded-full font-['Montserrat'] ${nivelCores[exercicio.nivel]}`}>
                      {exercicio.nivel}
                    </span>
                  </div>

                  <h3 className="font-display text-lg font-bold text-white mb-1 leading-snug">{exercicio.titulo}</h3>
                  <p className="text-gold-400 text-xs font-semibold mb-3 font-['Montserrat']">{exercicio.subtitulo}</p>
                  <p className="text-white/45 text-sm leading-relaxed mb-5 font-['Montserrat']">{exercicio.descricao}</p>

                  <div className="flex items-center justify-between pt-4 border-t border-gold-500/8">
                    <div className="flex items-center gap-1.5 text-white/50">
                      <i className="ri-target-line text-gold-400 text-sm"></i>
                      <span className="text-xs font-['Montserrat']">{exercicio.resultado}</span>
                    </div>
                    <div className="flex items-center gap-1 text-white/30">
                      <i className="ri-time-line text-xs"></i>
                      <span className="text-xs font-['Montserrat']">{exercicio.tempo}</span>
                    </div>
                  </div>
                </div>

                <div className={`overflow-hidden transition-all duration-300 ${hoveredCard === i ? 'max-h-14' : 'max-h-0'}`}>
                  <Link
                    to={exercicio.link}
                    className="flex items-center justify-center gap-2 w-full py-3.5 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] text-sm font-bold tracking-wide hover:from-gold-600 hover:to-gold-800 transition-all whitespace-nowrap font-['Montserrat']"
                  >
                    Acessar
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </ScrollRevealWrapper>
          ))}
        </div>

        {/* CTA */}
        <ScrollRevealWrapper animation="fade-up" delay={0.4}>
          <div className="text-center">
            <Link
              to="/exercicios-gratis"
              className="inline-flex items-center gap-3 px-10 py-4 bg-[#111111] border border-gold-500/20 text-white font-semibold rounded-full hover:border-gold-500/40 transition-all duration-300 text-sm tracking-wide whitespace-nowrap font-['Montserrat']"
            >
              <i className="ri-apps-line text-gold-400"></i>
              Ver todas as técnicas
              <i className="ri-arrow-right-line text-gold-400"></i>
            </Link>
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}
